// Componente per sistema ExeDialog DDT2026 - Step stampante e stamparescontrino
import React, { useState, useRef, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { ValoriVerificati } from './ValoriVerificati';

export function Stampante(props) {
    const { currURLSearchParams, onFinish, verificaData } = props;
    const inputRef = useRef();
    
    const opzioni = verificaData?.opzioni_selezione || [];
    const stampanteDefault = verificaData?.valori_accessori?.ddt?.stampante || '';
    
    const [state, setState] = useState({
        stampante: currURLSearchParams.get('stampante') || '',
        stamparescontrino: currURLSearchParams.get('stamparescontrino') === 'true'
    });

    // Imposta stampante di default da valori_accessori.ddt.stampante
    useEffect(() => {
        if (stampanteDefault && !state.stampante) {
            setState(prev => ({ ...prev, stampante: stampanteDefault }));
        }
    }, [stampanteDefault, state.stampante]);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [verificaData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        // stampante ammette stringa vuota o uno dei valori in elenco
        // stamparescontrino salvato come stringa 'true' o ''
        onFinish({
            stampante: state.stampante,
            stamparescontrino: state.stamparescontrino ? 'true' : ''
        });
    };

    return (
        <div className="card-body">
            <h5 className="card-title">Stampante</h5>
            <p className="text-muted">Seleziona la stampante per il DDT.</p>
            
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="stampante" className="form-label">Stampante</label>
                    <Dropdown 
                        ref={inputRef}
                        id="stampante"
                        value={state.stampante}
                        options={opzioni.map(o => ({ label: o.stampante || o || '(nessuna)', value: o.stampante || o }))}
                        onChange={(e) => setState({...state, stampante: e.value})}
                        placeholder="Seleziona stampante"
                        className="w-100"
                    />
                </div>

                <div className="mb-3">
                    <div className="field-checkbox">
                        <Checkbox 
                            inputId="stamparescontrino"
                            checked={state.stamparescontrino}
                            onChange={(e) => setState({...state, stamparescontrino: e.checked})}
                        />
                        <label htmlFor="stamparescontrino" className="ms-2">Stampa Scontrino</label>
                    </div>
                </div>

                <button className="btn btn-primary">
                    Prosegui
                </button>
            </form>
            
            <ValoriVerificati valori={verificaData?.valori_verificati} />
        </div>
    );
}

Stampante.displayName = 'stampante';
